import { apiClient } from "./api";

export const meterpointService = {
  async lookupByPostcode(postcode, energyType) {
    const endpoint = energyType === "electricity" ? "mpanLookup" : "mprnLookup";
    const payload = {
      postcode,
      energyType: energyType === "electricity" ? "electric" : "gas",
    };

    const response = await apiClient.post(
      `/api/v1/meterpoint/${endpoint}`,
      payload,
    );
    return response.results || [];
  },

  async validateMpan(mpan) {
    const response = await apiClient.get(
      `/api/v1/quote/validatempan?mpan=${mpan}`,
    );
    return response;
  },
};
